import _ from '@/utils/lodash-optimized'

import http from '../../lib/http'
import { queryClient } from '../../lib/query-client'
import { getChatsMetaQueryKey, getChatsQueryKey } from '../chats'
import { setClientName } from '../PatientFolder/actions'
import { getPatientBanner, reset } from '../PatientFolder/PatientBanner/actions'
import { newToast } from '../shared/toast-stack/actions'

import { humanName } from './utils'

export const GET_CHATS = 'chat/GET_CHATS'
export const GET_CHATS_SUCCESS = 'chat/GET_CHATS_SUCCESS'
export const GET_CHATS_FAIL = 'chat/GET_CHATS_FAIL'
export const APPEND_MESSAGE = 'chat/APPEND_MESSAGE'

export const GET_CHAT_PATIENT_SUCCESS = 'chat/GET_CHAT_PATIENT_SUCCESS'
export const GET_CHAT_PATIENT_FAIL = 'chat/GET_CHAT_PATIENT_FAIL'
export const CLEAR_CHAT_PATIENT = 'chat/CLEAR_CHAT_PATIENT'

export const SEARCH_PARTICIPANTS_SUCCESS = 'chat/SEARCH_PARTICIPANTS_SUCCESS'
export const SEARCH_PARTICIPANTS_FAIL = 'chat/SEARCH_PARTICIPANTS_FAIL'

export const NEW_CHAT = 'chat/NEW_CHAT'

export const ACK_READ = 'chat/ACK_READ'

export const UPDATE_CHATS = 'chat/UPDATE_CHATS'

export const RECEIVE_LOADING_START = 'chat/RECEIVE_LOADING_START'
export const RECEIVE_LOADING_END = 'chat/RECEIVE_LOADING_END'
export const RECEIVE_LOADING_ERROR = 'chat/RECEIVE_LOADING_ERROR'

export const MESSAGES_LOADING_START = 'chat/MESSAGES_LOADING_START'
export const MESSAGES_LOADING_END = 'chat/MESSAGES_LOADING_END'

export const MESSAGE_SEND_START = 'chat/MESSAGE_SEND_START'
export const MESSAGE_SEND_END = 'chat/MESSAGE_SEND_END'
export const MESSAGE_SEND_ERROR = 'chat/MESSAGE_SEND_ERROR'

export const NEW_MESSAGE_RECEIVED = 'chat/NEW_MESSAGE_RECEIVED'
export const ADD_CHAT = 'chat/ADD_CHAT'
export const MESSAGES_PAGE_SIZE = 20

export const GET_URL_PREVIEW_END = 'chat/GET_URL_PREVIEW_END'

const getId = ref => ref.split('/')[1]

export const displayToastIfNeeded = (message, chat, clientName) => (dispatch, getState) => {
  const state = getState()

  const { profile, status } = state?.auth ?? {}
  const { chatId } = state.globalVars?.params ?? {}
  const userId = profile?.sub

  if (!userId) {
    return
  }

    const statuses = status?.data ?? []
  const patientId = chat.meta.patient.id

    const isUserConcierge = _.find(statuses, s => s.id === userId)?.concierge ?? false

  const isCareTeamChat = chat.meta.concierge
  const [ authorResourceType, authorId ] = message.author && message.author.split('/')

  const shouldDisplay = authorId !== userId && chat?.id !== chatId
  if (!shouldDisplay) {
    return
  }

  const authorResource = chat.participants.find(
    pt => pt.id === authorId && pt.resourceType === authorResourceType
  )

  const toast = {
    type: 'message',
    author: authorResource,
    createdAt: message.created_at,
    message: message.body,
    patientId,
    clientName,
    chatId: chat.id
  }

  if (isCareTeamChat) {
    if (isUserConcierge) {
      dispatch(newToast(toast))
    }
  } else {
    dispatch(newToast(toast))
  }
}

export function ackRead () {
  return function dispatchFunc (dispatch, getState) {
    const state = getState()

    const userId = state.auth?.profile?.sub
    const chatId = state.globalVars?.params?.chatId
    const chats = state.messages?.chats ?? {}

    if (!chatId || !userId) {
      return null
    }

    const { id, meta, clientName, messages } = chats[chatId]
    const { patient_id: patientId, forParticipant } = meta

      const offset = _.last(messages)?.chat_offset
    const currentPractitioner = `Practitioner/${userId}`
    const participant = forParticipant || currentPractitioner

    http
      .putRequest(
        `/patients/${getId(patientId)}/chats/${id}/ack?participant=${participant}&offset=${offset || 0}`,
        {},
        { clientName }
      )
      .then(data => {
        let chatsQueryKey = getChatsQueryKey({ userId })
        queryClient.invalidateQueries({ queryKey: getChatsMetaQueryKey({ userId }), exact: false })
          .catch((e) => {
            console.warn(e)
          })
        queryClient.invalidateQueries({ queryKey: chatsQueryKey, exact: false })
          .catch((e) => {
            console.warn(e)
          })
        return dispatch({
          type: ACK_READ,
          chatId: id,
          meta: data.chat.meta
        })
      })
      .catch(err => {
        console.warn(err)
      })

    dispatch({
      type: ACK_READ,
      chatId: id,
      meta
    })
    return null
  }
}

export const markAsRead = (chatId) => {
  http.postRequest(`/chats/${chatId}/mark-as-read`)
}

export const newMessageReceived =
  (message, chat, clientName) => (dispatch, getState) => {
    const state = getState()
    const chats = state.messages?.chats ?? {}
    const chatId = state.globalVars?.params?.chatId

    // dispatch(displayToastIfNeeded(message, chat, clientName))

    const existingChat = chats[chat.id]

    if (existingChat) {
      if (existingChat.chat_offset < message.chat_offset) {
        dispatch({
          type: NEW_MESSAGE_RECEIVED,
          chatId: chat.id,
          message
        })

        if (existingChat.id === chatId) {
          dispatch(ackRead())
        }
      }
    } else {
      dispatch({
        type: ADD_CHAT,
        chatId: chat.id,
        chat
      })
      dispatch({
        type: NEW_MESSAGE_RECEIVED,
        chatId: chat.id,
        message
      })
    }
  }

export const clearChatPatient = () => ({
  type: CLEAR_CHAT_PATIENT
})

const setPatient = patient => ({
  type: GET_CHAT_PATIENT_SUCCESS,
  patientName: humanName(patient.name),
  patient
})

export const getPatient = () => (dispatch, getState) => {
  dispatch(clearChatPatient())
  const state = getState()
  const { id: patientId, clientName } = state?.globalVars?.params ?? {}

  dispatch(setClientName(clientName))
  return http
    .getRequest(`/patients/${patientId}`, null, { clientName })
    .then(data => {
      dispatch(reset())
      dispatch(setPatient(data))
      dispatch(getPatientBanner())
    })
    .catch(err => {

      void err

      dispatch({
        type: GET_CHAT_PATIENT_FAIL,
        payload: {
          status: err.response.status
        }
      })
    })
}

export const newChat = bool => ({
  type: NEW_CHAT,
  bool
})

const updateChat = list => ({
  type: UPDATE_CHATS,
  chats: list
})

export const loadMoreHistory = () => (dispatch, getState) => {
  dispatch({ type: MESSAGES_LOADING_START })
  const state = getState()

  const userId = state.auth?.profile?.sub
  const chatId = state.globalVars?.params?.chatId
  const chats = state.messages?.chats ?? {}

  if (!chatId || !userId) {
    return null
  }

  const {
    id,
    clientName,
    meta: { patient_id: patientId, forParticipant },
    messages = [],
    chat_offset: chatOffset
  } = chats[chatId]

  const offsets = messages.map(m => m.chat_offset)
  let minOffset = Math.min.apply(null, offsets.concat([ chatOffset ]))

  if (!_.isNumber(minOffset) || !_.isFinite(minOffset)) {
    minOffset = chatOffset
  }
  const isFirstReceipt = minOffset === chatOffset
  const to = isFirstReceipt ? minOffset + 1 : minOffset
  const from = Math.max(to - MESSAGES_PAGE_SIZE - 1, 0)
  const currentPractitioner = `Practitioner/${userId}`

  const participant = forParticipant || currentPractitioner

  return http
    .getRequest(
      `/patients/${getId(patientId)}/chats/${id}/receive?participant=${participant}&from=${from}&to=${to}&limit=${MESSAGES_PAGE_SIZE}`,
      null,
      { clientName }
    )
    .then(resp => {
      if (resp.entries.length) {
        return Promise.resolve(
          resp.entries.map(e => ({
            ...e.message,
            chat_offset: e.offset
          }))
        )
      }
      return Promise.resolve([])
    })
    .then(entries => {
      if (entries.length) {
        const ids = messages.map(m => m.id)
        chats[id].messages = entries
          .filter(e => ids.indexOf(e.id) === -1)
          .concat(messages || [])

        dispatch({ type: MESSAGES_LOADING_END })
        dispatch(updateChat(chats))
        dispatch(ackRead())
      } else {
        dispatch({ type: MESSAGES_LOADING_END })
      }
    })
    .catch(console.warn)
}

export function ensureChatSelected (chatId) {
  return function (dispatch, getState) {
    let state = getState()

    if (
      state.messages?.messagesLoading ||
      state.messages?.receiveLoading
    ) {
      return
    }

    dispatch(selectChat(chatId))
  }
}

export function selectChat (chatId, navigate) {
  return function dispatchFunc (dispatch, getState) {
    if (!chatId) {
      return
    }

    let state = getState()
    let chat = state.messages?.chats?.[chatId]

    if (!chat) {
      return
    }

    let { id, meta, clientName, messages } = chat
    let url = `/patient/${clientName}/${getId(meta.patient_id)}/messages/${id}`

    navigate?.(url)

    if (chat.is_marked_unread) {
      markAsRead(chatId)
    }

    if (
      !Array.isArray(messages) ||
      !messages.length
    ) {
      dispatch(loadMoreHistory())
      return
    }

    dispatch(ackRead())
  }
}

const setChats = chats => ({
  type: GET_CHATS_SUCCESS,
  chats
})

export const getChats = () => (dispatch, getState) => {
  const state = getState()

  const { loading } = state
  const userId = state.auth?.profile?.sub

  if (!userId) {
    return null
  }

  dispatch({ type: GET_CHATS })

  const url = `/messages/chats?participant=Practitioner/${userId}`

  if (!loading) {
    return http
      .getRequest(url)
      .then(data => {
        dispatch(setChats(data.chats))
      })
      .catch(error => {
        dispatch({
          type: GET_CHATS_FAIL,
          error
        })
      })
  }
  return null
}

export const sendMessage = (msg, uploadId, newMessageId, imageName, callback) => (dispatch, getState) => {
  const state = getState()

  const userId = state.auth?.profile?.sub
  const chatId = state.globalVars?.params?.chatId
  const chats = state.messages?.chats ?? {}

  if (!chatId || !userId) return null

  const {
    id,
    meta: { patient_id: patientId, forParticipant },
    clientName
  } = chats[chatId]

  const currentPractitioner = `Practitioner/${userId}`

  const url = `/patients/${getId(patientId)}/chats/${id}/publish?participant=${
    forParticipant || currentPractitioner
  }`

  const payload = {
    message: {
      body: msg?.trim() ?? ''
    }
  }

  if (uploadId) {
    payload.message.attachments = [{
      type: 'aidbox',
      id: uploadId,
      filename: imageName
    }]
  }

  return http.postRequest(url, payload, { clientName })
    .then(message => {
      dispatch({
        type: MESSAGE_SEND_END,
        chatId: id,
        messageId: newMessageId,
        message
      })

      callback?.()
    }).catch(e => {
      if (
        typeof e?.response?.status === 'number' &&
        e.response.status >= 400
      ) {
        dispatch({
          type: MESSAGE_SEND_ERROR,
          chatId: id,
          messageId: newMessageId
        })
      }
    })
}

export const sendMessageError = newMessageId => (dispatch, getState) => {
  const {
    messages: { chats },
    globalVars: {
      params: { chatId }
    }
  } = getState()

  if (!chatId) return null

  const {
    id
  } = chats[chatId]
  return dispatch({
    type: MESSAGE_SEND_ERROR,
    chatId: id,
    messageId: newMessageId
  })
}

export const createChat = participantsList => (dispatch, getState) => {
  const state = getState()

  const userId = state.auth?.profile?.sub
  const clientName = state.globalVars?.params?.clientName
  const patientId = state.globalVars?.params?.id
  const chats = state.messages?.chats ?? {}

  if (!userId) {
    return Promise.resolve(null)
  }

  const participants = _.uniq(
    participantsList
      .map(p => p.id)
      .concat([ `Practitioner/${userId}` ])
      .sort()
  )

  const existingChatId = _.findKey(
    chats,
    c =>
      _.isEqual(
          c?.participants ?? []
          .map(p => `${p.resourceType}/${p.id}`)
          .sort(),
        participants
      ) && c?.meta?.patient_id === `Patient/${patientId}`
  )

  if (existingChatId) {
    const existingChat = chats[existingChatId]

    dispatch(newChat(false))

    return Promise.resolve(`/patient/${existingChat.clientName}/${existingChat.meta.patient.id}/messages/${existingChat.id}`)
  }

  const form = {
    subject: 'no subject',
    participants
  }

  return http
    .postRequest(`/patients/${patientId}/chats`, form, { clientName })
    .then(c => {
      if (c.exist) {
        return `/patient/${clientName}/${patientId}/messages/${c.exist}`
      }
      return http.getRequest(`/messages/chats/${c.id}?participant=Practitioner/${userId}`, {}, { clientName })
    })
    .then(resp => {
      const c = resp?.chat
      c.clientName = clientName
      chats[c.id] = c
      dispatch(newChat(false))
      dispatch(updateChat(chats))
      return `/patient/${c.clientName}/${c.meta.patient.id}/messages/${c.id}`
    })
}

const toParticipant = res => {
  if (res.resourceType === 'Practitioner') {
    return {
      type: 'Practitioner',
      display: humanName(res.name),
      id: `Practitioner/${res.id}`
    }
  }
  if (res.resourceType === 'Patient') {
    return {
      type: 'Patient',
      display: humanName(res.name),
      id: `Patient/${res.id}`
    }
  }
  if (res.resourceType === 'RelatedPerson') {
    return {
      type: 'RelatedPerson',
      display: humanName(res.name),
      id: `RelatedPerson/${res.id}`
    }
  }
  return null
}

export const searchParticipants = txt => (dispatch, getState) => {
  const state = getState()

  const userId = state.auth?.profile?.sub
  const clientName = state.globalVars?.params?.clientName
  const patientId = state.globalVars?.params?.id

  if (!userId) {
    return
  }

  Promise.all([
    http.getRequest(
      '/practitioners', {
        name: txt,
        active: true,
        _count: 20
      }, { clientName }
    ),
    http.getRequest(`/patients/${patientId}`, {}, { clientName }),
    http.getRequest(
      `/v2/patients/${patientId}/supportNetwork?relationship=ff&enrolledOnly=true`, {}, { clientName }
    )
  ])
    .then(([ practs, pat, relers ]) => {
      const participants = practs
        .filter(p => p.id !== userId)
        .map(toParticipant)
        .concat([ pat ].map(x => toParticipant(x)))
        .concat(relers.entry.map(e => toParticipant(e.resource)))
      dispatch({
        type: SEARCH_PARTICIPANTS_SUCCESS,
        practitionersSearch: participants.sort(x => x.display) || []
      })
    })
    .catch(error => dispatch({
      type: SEARCH_PARTICIPANTS_FAIL,
      error
    }))
}

export const sendMessageStart = (msg, newMessageId) => (dispatch, getState) => {
  const state = getState()

  const userId = state.auth?.profile?.sub
  const chats = state.messages?.chats ?? {}
  const chatId = state.globalVars?.params?.chatId

  const {
    id,
    meta: { forParticipant }
  } = chats[chatId]

  const currentPractitioner = `Practitioner/${userId}`

  const message = {
    id: newMessageId,
    body: msg,
    author: forParticipant || currentPractitioner
  }

  return dispatch({
    type: MESSAGE_SEND_START,
    chatId: id,
    message
  })
}

const setUrlPreview = (chatId, messageId, urlPreview) => {
  return ({
    type: GET_URL_PREVIEW_END,
    url_preview: urlPreview,
    messageId,
    chatId
  })
}

export const getUrlPreview = (messageId, preview) => (dispatch, getState) => {
  const {
    messages: { chats },
    globalVars: {
      params: { chatId }
    }
  } = getState()

  if (!chatId) return null

  const {
    id
  } = chats[chatId]
  const url = '/messages/url'

  const previewURL = preview.substring(0, 4) === 'http' ? preview : `https://${preview}`

  return http.getRequest(url, { url: previewURL })
    .then(res => {
      if (Object.prototype.hasOwnProperty.call(res, 'e')) {
        return
      }
      dispatch(setUrlPreview(id, messageId, res))
    })
    .catch(() => {
      console.warn(`Can't load preview - ${previewURL}`)
    })
}

export const getDocument = (
  patientId,
  chatId,
  attachmentId,
  meta,
  clientName,
  type
) => {
  const url =
    type === 'MessageAttachment'
      ? `/patients/${patientId}/messages/${chatId}/attachment/${attachmentId}?participant=${meta.participantId || meta.forParticipant}&downloadType=preview`
      : `/patients/${patientId}/documents/${attachmentId}?documentType=${type}&downloadType=preview`

  if (patientId && chatId && attachmentId && meta && clientName) {
    return http.getRequest(url, {}, { clientName })
  }
}

export const getImage = (patientId, chatId, attachmentId, meta, clientName) => {
  const url =
    `/patients/${patientId}/messages/${chatId}/attachment/${attachmentId}?participant=${meta.participantId || meta.forParticipant}&downloadType=preview`

  if (patientId && chatId && attachmentId && meta && clientName) {
    return http.getRequest(url, {}, { clientName })
  }
}
